import { connect } from 'react-redux';

import CountTodos from 'components/molecules/HeaderNav/additions/views/countTodos';
import { getTodayFromCalendar } from 'store/programDays';
import { ProgramDayMinType } from 'store/programDays';
import { getCurrentViewID } from 'store/view';

const mapStateToProps = (state: any) => ({
	currentViewID: getCurrentViewID(state),
	count: ((calendar?: ProgramDayMinType): number => {
		return calendar && calendar.openItems ? calendar.openItems : -1;
	})(getTodayFromCalendar(state) as any),
});

export default connect(mapStateToProps)(CountTodos as any);
